<script lang="ts">
import { computed, defineComponent } from 'vue';

import Checkbox from '@/components/base/form/Checkbox.vue';

export default defineComponent({
  name: 'NewsletterSignup',
  props: {
    modelValue: { required: false, type: Boolean },
  },
  components: {
    Checkbox,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const subscribed = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val),
    });

    return {
      subscribed,
    };
  },
});
</script>

<template>
  <div data-test="cx-newsletter-signup">
    <Checkbox
      v-model="subscribed"
      class="text-base font-normal"
      data-test="cx-newsletter-signup-checkbox"
    >
      Sign up for email newsletters
    </Checkbox>
    <div class="text-sm text-neutral-500">
      Sign up for special offers, promotions and new products.
    </div>
  </div>
</template>
